import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type MedicalLogCoverPageProps = PropsFromRedux & OwnProps;
function MedicalLogCoverPage(props: MedicalLogCoverPageProps) {
    const { vesselInfo, selectedDate } = props;
    const medicalLogData = {
        firstPage: {

        },
    };

    const { firstPage } = medicalLogData;
    return (
        <>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">MEDICAL LOG BOOK</h2>
                </div>
                <div className='font-bold'>
                    <p
                        className="p-0.5 m-0.5 flex items-center"
                        style={{ minWidth: 350, fontSize: 18 }}
                    >
                        <span style={{ minWidth: 120 }}>
                            Vessel Name:
                        </span>
                        <span
                            className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                            style={{ minHeight: 18 }}
                        >
                            {vesselInfo?.vesselName}
                        </span>
                    </p>
                    <p
                        className="p-0.5 m-0.5 flex items-center gap-4"
                        style={{ minWidth: 350, fontSize: 18 }}
                    >
                        <span style={{ minWidth: 120 }}>PERIOD</span>
                        <span className="flex w-full items-center">
                            <span className="flex w-full items-center">
                                From:
                                <span
                                    className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                    style={{ minHeight: 18 }}
                                >
                                    {moment(
                                        props.dateRange?.startDate
                                    ).format('DD-MMM-YY')}{' '}
                                </span>
                            </span>
                            <span className="flex w-full items-center">
                                To:
                                <span
                                    className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full"
                                    style={{ minHeight: 18 }}
                                >
                                    {moment(
                                        props.dateRange?.endDate
                                    ).format('DD-MMM-YY')}{' '}
                                </span>
                            </span>
                        </span>
                    </p>
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                        <p className="p-0.5 m-0.5 border-b-2 border-gray-900 w-full">
                            English
                        </p>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left print-page-break">
                <h2 className="uppercase text-2xl font-semibold text-center print:py-4 mb-16">
                    Instructions
                </h2>
                <p className="mb-4">
                    This medical log shall be kept updated by the assigned Officer as designated
                    by the Master.
                    All entries in the log shall be made in ink.
                </p>

                <p className="mb-4">
                    This log shall be maintained for any treatment administered
                    to ship’s staff for illnesses or injuries.
                </p>

                <p className="mb-4">
                    Every case of illness and/or injury happening to any person on board, with the
                    nature thereof, the medical treatment, and every arrangement of medical care of
                    crew on shore shall be entered and recorded.
                    Entries for illness or injury, and the corresponding
                    treatment should be in as much detail as is practicable, to allow the
                    incident to be satisfactorily reconstructed at a later date, if so required.
                </p>

                <p className="mb-4">
                    The sanitary condition of crew's quarter, messrooms, washrooms and toilets, galley,
                    provision and other stores room, hospital and other places after the sanitary
                    inspections made by the Master and/or Chief Officer and Chief Engineer, shall be
                    entered and recorded.
                </p>

                <p className="mb-4">
                    Every work done by crew in relation to cleanliness and sanitation of the living quarters,
                    and any other performance done in relation to sanitation, medical care and health of crew
                    shall be entered and recorded.
                </p>

                <p className="mb-4">
                    The master shall make round for sanitary inspection directly at least once a week and 
                    have the chief officer carry out the inspection at least once in three days of the 
                    living quarters so as to ensure the subject spaces are kept neat, clean and are healthy 
                    at all times.
                </p>

                <p className="mb-4">
                    Whenever Radio Medical Advice has been obtained for the
                    treatment of a patient, this fact should be clearly mentioned in the “Treatment”
                    column. The entry should read as “As per Radio Medical Advice obtained
                    from <u>(Name of Coast Station or Shore Medical Authority)</u>”.
                </p>

                <p className="mb-4">
                    An entry in <strong>red ink</strong> must be made in the
                    column “Medicines” whenever it has been necessary to administer a controlled drug
                    (narcotic) to a patient. The Master must append his signature to the relevant entry
                    to indicate his knowledge of and approval of the medication being given to the patient.
                </p>

                <p className="mb-4">Injuries are to be categorized as follows:</p>

                <ol className='ml-4 list-decimal marker:font-bold'>
                    <li className="mb-4">
                        <strong>Lost Time Injury or Lost Workday Case (LWC)</strong>
                        <p>
                            This is an injury that results in an individual being unable to carry out any
                            of his duties or to return to work on a scheduled work on the day following
                            the injury unless caused by delays in getting medical treatment ashore/onboard.
                        </p>
                        <p>
                            LWC should be a value representative to a case and should not represent the
                            number of days lost due to an individual case.
                        </p>
                    </li>

                    <li className="mb-4">
                        <strong>Restricted Work Case (RWC)</strong>
                        <p>
                            This is an injury which results in an individual being unable to perform all
                            normally assigned work functions during a scheduled work or being assigned
                            to another job on a temporary or permanent basis on the day following the injury.
                        </p>
                        <p>The following come into the category of “less than normal assigned work function”:</p>
                        <ul>
                            <li className="ml-8">
                                Performing all duties or normal assigned work functions but
                                at less than full time schedules;
                            </li>
                            <li className="ml-8">
                                Performing limited duties at normally assigned job at
                                fulltime schedule;
                            </li>
                            <li className="ml-8">Transfer to other duties.</li>
                        </ul>
                    </li>

                    <li className="mb-4">
                        <strong>Medical Treatment Case (MTC)</strong>
                        <p>
                            This is loss of consciousness (unless due to ill health), injury or work-related
                            illness. This requires more than first aid treatment by a physician, dentists,
                            surgeon or registered medical personnel. e.g. nurse or paramedic under the
                            standing orders of a physician, or under the specific order of a physician or
                            if at sea with no physician onboard could be considered as being in the province
                            of a physician.
                        </p>

                        <p>MTCs include:</p>
                        <ul>
                            <li className="ml-8">
                                Injuries, which result in loss of consciousness, even if
                                the individual resumes work after regaining consciousness. (N.B. this does
                                not cover loss of consciousness due to ill health)
                            </li>
                            <li className="ml-8">Sutures for non-cosmetic purpose</li>
                            <li className="ml-8">Use of casts, splints or other means of immobilization</li>
                            <li className="ml-8">Any general surgical treatment</li>
                            <li className="ml-8">Removal of embedded objects from eye by surgical means</li>
                            <li className="ml-8">Use of other than non-prescriptive drugs or medications</li>
                            <li className="ml-8">
                                Use of a series of compresses for treatment of bruises,
                                sprains or strains
                            </li>
                        </ul>

                        <p>MTCs exclude the following:</p>
                        <ul>
                            <li className="ml-8">First aid, LWC, and RWC</li>
                            <li className="ml-8">Hospitalization for observation without treatment</li>
                            <li className="ml-8">One-off tetanus injection</li>
                            <li className="ml-8">
                                Consultative visit to, or examination by, a physician or
                                registered professional for the purpose of a confirmatory check.
                            </li>
                        </ul>
                    </li>
                    <li className="mb-4">
                        <strong>First Aid Case (FAC)</strong>
                        <p>
                            This is any one-time treatment and subsequent observation or minor injuries such
                            as bruises, scratches, cuts, burns, splinters, etc. The First aid may or may not
                            be administered by a physician or registered professional.
                        </p>
                        <p>FACs includes:</p>
                        <ul className="mb-4">
                            <li className="ml-8">Follow-up visits to a physician or nurse for observation
                                ONLY, or for routine dressing change;</li>
                            <li className="ml-8">Negative X-ray Results;</li>
                            <li className="ml-8">Cleaning abrasions/wounds with antiseptic and applying dressing;</li>
                            <li className="ml-8">
                                Irritation of eye and removal of non-embedded foreign
                                objects using a cotton swab;
                            </li>
                            <li className="ml-8">
                                One time administration of oxygen after exposure to toxic
                                atmosphere and resumption of normal (but not restricted) work the Following Day;
                            </li>
                            <li className="ml-8">
                                Soaking, application of hot-cold Compress And Use of elastic
                                Bandage On sprains and Strains immediately after injury;
                            </li>
                            <li className="ml-8">Applying one-Off cold compress or limited soaking of bruise;</li>
                            <li className="ml-8">Use of non-prescriptive medicines;</li>
                            <li className="ml-8">A use of elastic bandages;</li>
                            <li className="ml-8">Treatment of first Degree burns.</li>
                        </ul>

                        <p className='mb-4'>
                            <strong>An Entry in red ink</strong> shall be made whenever an injury categorized
                            as LWC or RWC.
                        </p>

                        <p className='mb-4'>
                            An injury or illness that ultimately requires evacuation of the patient shall be
                            appropriately documented in the Log, giving details of the patient, his injury or
                            illness, method of evacuation and place of evacuation. This shall be deemed to
                            be a LWC.
                        </p>

                        <p className='mb-4'>
                            An illness or injury that ultimately requires the hospitalizations and sign off of a crewmember shall be appropriately documented in the log, giving details of the patient, his injury or illness and port of disembarkation. This shall be deemed to be an LWC or LTI.
                        </p>

                        <p className='mb-4'>
                            An Appropriate entry shall be made in the log for any crewmember who has gone ashore to seek medical treatment, which shall include the particulars of the individual, details of the injury or illness, treatment given and medicines prescribed. Any follow up action required by the ship’s medical officer should be suitably recorded in subsequent entries.
                        </p>

                        <p className='mb-4'>
                            The Master shall verify the accuracy of the record in the logbook at intervals not exceeding a month.
                        </p>
                    </li>
                </ol>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);

    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(MedicalLogCoverPage);
